import React from 'react';

export declare type FocusType = 'false' | 'true';

export type IconProps = {
  className?: string;
  color?: string;
  focusable?: FocusType;
  height?: number;
  onClick?: () => void;
  size?: number;
  width?: number;
};

export const Phone: React.FC<IconProps & JSX.IntrinsicElements['svg']> = ({
  className = '',
  color = '#090C33',
  focusable = 'false',
  height,
  onClick,
  size = 24,
  width,
  ...rest
}) => {
  const iconColor = undefined;

  return (
    <svg
      fill="none"
      height={height || size}
      width={width || size}
      onClick={onClick}
      className={className}
      focusable={focusable}
      {...rest}
      viewBox="0 0 24 24"
    >
      <path
        stroke={iconColor || color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15.308 14.188L13.167 16.3a17.371 17.371 0 01-3.092-2.375c-.904-.94-1.7-1.977-2.375-3.093l2.11-2.141A.918.918 0 0010 7.686L7.8 2.558a.918.918 0 00-1.078-.525L2.688 3.1A.919.919 0 002 4.016 19.4 19.4 0 007.49 16.51 19.4 19.4 0 0019.986 22a.915.915 0 00.917-.687l1.066-4.036a.917.917 0 00-.524-1.078L16.316 14a.917.917 0 00-1.008.188v0z"
      />
    </svg>
  );
};
